"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalCssProperties = ['auto', 'initial', 'inherit'];